import SharedAsset from '@zenbusiness/common-components/SharedAsset';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

import { UserMenu } from '../UserMenu';
import AppHeaderLogo from './AppHeaderLogo';

import { useDrawerState } from '../hooks/useDrawerState';

const AppHeader = () => {
  const theme = useTheme();
  const { drawerState, toggleDrawer } = useDrawerState();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1.5rem',
        justifyContent: 'space-between',
        paddingBlock: '1rem'
      }}
    >
      <IconButton
        edge="start"
        data-testid={drawerState ? 'close-drawer' : 'open-drawer'}
        aria-label="open drawer"
        color="inherit"
        onClick={toggleDrawer}
        tabIndex={0}
        size="large"
        sx={{
          borderRadius: '0.5rem',
          height: '3.25rem',
          justifySelf: 'start',
          marginLeft: 0,
          order: 0,
          padding: 0,
          width: '3.25rem',
          display: 'none',
          [theme.breakpoints.down('md')]: {
            display: 'flex'
          }
        }}
      >
        {drawerState && (
          <SharedAsset
            src="/s2/icon/e-remove-outline.svg"
            width={24}
          />
        )}

        {!drawerState && (
          <SharedAsset
            src="/s2/icon/zb-menu-outline.svg"
            width={32}
          />
        )}
      </IconButton>

      <Box
        data-testid="logo-container"
        sx={{
          order: 1,
          display: 'none',
          [theme.breakpoints.down('md')]: {
            display: 'block'
          }
        }}
      >
        <AppHeaderLogo />
      </Box>

      <Box
        sx={{
          order: 3
        }}
      >
        <UserMenu />
      </Box>
    </Box>
  );
};

export default AppHeader;
